document.addEventListener('DOMContentLoaded', function () {
    const countdownElement = document.querySelector(".wrapper-counter");
    if (countdownElement) {
		let datasetTime = countdownElement.dataset.time;
        let today = new Date(datasetTime);
        today.setHours(23, 59, 59, 0); // Set the time to 23:59:59
        let offset = today.getTimezoneOffset();
        today = new Date(today.getTime() + (offset + 120) * 60000);
				
        if(countdownElement.dataset.isAuto == "true") {
            setInterval(function() {
                const daysElement = countdownElement.querySelector(".days");
                const hoursElement = countdownElement.querySelector(".hours");
                const minutesElement = countdownElement.querySelector(".min");
                const secondsElement = countdownElement.querySelector(".sec");
                const date = new Date();
                const startDate = new Date('2024-01-01 00:00:00');
                const timeDifference = date.getTime() - startDate.getTime();
                const days = parseInt(countdownElement.dataset.duration) - 1 - (Math.floor(timeDifference / (1000 * 60 * 60 * 24) % parseInt(countdownElement.dataset.duration)));
                const hours = 23 - Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = 59 - Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = 59 - Math.floor((timeDifference % (1000 * 60)) / 1000);

                daysElement.textContent = String(days).padStart(2, "0");
                hoursElement.textContent = String(hours).padStart(2, "0");
                minutesElement.textContent = String(minutes).padStart(2, "0");
                secondsElement.textContent = String(seconds).padStart(2, "0");
            }, 1000);
        }
        else {

            // Add the offset to UTC
            // today.setHours(today.getHours());
            const targetDate = today.getTime();
            const daysElement = countdownElement.querySelector(".days");
            const hoursElement = countdownElement.querySelector(".hours");
            const minutesElement = countdownElement.querySelector(".min");
            const secondsElement = countdownElement.querySelector(".sec");
    
            const updateCountdown = () => {
                const date = new Date();
    
                var offsetTime = date.getTimezoneOffset();
                const currentDate = new Date(date.getTime() + (offsetTime + 120) * 60000);
    
    
                const localCurrentDate = new Date(currentDate.getTime());
                const localCurrentTime = localCurrentDate.getTime();
                const timeDifference = targetDate - localCurrentTime;
    
                if (timeDifference <= 0) {
                    daysElement.textContent = "00";
                    hoursElement.textContent = "00";
                    minutesElement.textContent = "00";
                    secondsElement.textContent = "00";
                } else {
                    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    
                    daysElement.textContent = String(days).padStart(2, "0");
                    hoursElement.textContent = String(hours).padStart(2, "0");
                    minutesElement.textContent = String(minutes).padStart(2, "0");
                    secondsElement.textContent = String(seconds).padStart(2, "0");
                }
            };
    
            updateCountdown();
            setInterval(updateCountdown, 1000);

        }
    }
});